import { render, staticRenderFns } from "./hk4.vue?vue&type=template&id=1c463194"
import script from "./hk4.vue?vue&type=script&lang=js"
export * from "./hk4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports